import { render } from "./VisitModalNotificationsPart.vue?vue&type=template&id=2e212426&scoped=true"
import script from "./VisitModalNotificationsPart.vue?vue&type=script&lang=js"
export * from "./VisitModalNotificationsPart.vue?vue&type=script&lang=js"

import "./VisitModalNotificationsPart.vue?vue&type=style&index=0&id=2e212426&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e212426"]])

export default __exports__